import {
  getOrgChartPersonFieldPacks,
  getOrgChartPositionFieldPacks,
  getOrgChartDepartmentFieldPacks,
  getOrgChartTeamFieldPacks,
  getOrgChartProjectFieldPacks,
  getOrgChartRoleProfileFieldPacks,
} from './fieldPackToManifest';

import {
  ORG_PERSON_NODE_TYPES as PERSON_NODE_TYPES,
  ORG_POSITION_NODE_TYPES as POSITION_NODE_TYPES,
} from '../constants/orgNodeTypes';

export function isPersonNodeType(nodeType: string): boolean {
  return PERSON_NODE_TYPES.has(nodeType);
}

export function isPositionNodeType(nodeType: string): boolean {
  return POSITION_NODE_TYPES.has(nodeType);
}

/** Resolve the logical org presentation type carried by a generic `org-shape`. */
export function resolveOrgNodeType(node: {
  readonly type: string;
  readonly attrs?: Readonly<Record<string, unknown>>;
  readonly props?: Readonly<Record<string, unknown>>;
}): string {
  if (node.type !== 'org-shape') return node.type;
  const variant = node.attrs?.variant ?? node.props?.variant;
  return typeof variant === 'string' ? variant : node.type;
}

export function getFieldPacksForNodeType(nodeType: string): string[] | undefined {
  if (PERSON_NODE_TYPES.has(nodeType)) return getOrgChartPersonFieldPacks();
  if (POSITION_NODE_TYPES.has(nodeType)) return getOrgChartPositionFieldPacks();
  switch (nodeType) {
    case 'org_department':
      return getOrgChartDepartmentFieldPacks();
    case 'org_team':
      return getOrgChartTeamFieldPacks();
    case 'org_project':
      return getOrgChartProjectFieldPacks();
    case 'org_role_profile':
      return getOrgChartRoleProfileFieldPacks();
    default:
      return undefined;
  }
}

export function getEntityLabel(nodeType: string): string {
  if (PERSON_NODE_TYPES.has(nodeType)) return 'Person';
  if (POSITION_NODE_TYPES.has(nodeType)) return 'Position';
  switch (nodeType) {
    case 'org_department':
      return 'Department';
    case 'org_team':
      return 'Team';
    case 'org_project':
      return 'Project';
    case 'org_role_profile':
      return 'Role Profile';
    default:
      return 'Entity';
  }
}

export function getEntityLabelI18nKey(nodeType: string): string {
  if (PERSON_NODE_TYPES.has(nodeType)) return 'person';
  if (POSITION_NODE_TYPES.has(nodeType)) return 'position';
  switch (nodeType) {
    case 'org_department':
      return 'department';
    case 'org_team':
      return 'team';
    case 'org_project':
      return 'project';
    case 'org_role_profile':
      return 'roleProfile';
    default:
      return 'entity';
  }
}

export const ALL_ORG_NODE_TYPES = [
  ...Array.from(PERSON_NODE_TYPES),
  ...Array.from(POSITION_NODE_TYPES),
  'org_department',
  'org_team',
  'org_project',
  'org_role_profile',
];
